module.exports = __webpack_public_path__ + "static/media/download-white.eff5aa32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/download-white.svg
// module id = 470
// module chunks = 2